import styled from "styled-components";
import { colors } from "../common/element/elements.js";

export const Styles = styled.div`
  /* Pagination */
  ul.pagination-box {
    margin-top: 20px;
    li {
      margin-right: 15px;
      a,
      button {
        font-size: 16px;
        color: ${colors.red};
        width: 38px;
        height: 38px;
        border: 1px solid ${colors.border3};
        background-color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        padding: 0;
        line-height: 1;
        transition: all 0.2s ease;
        text-decoration: none;

        i {
        }
        &:hover {
          background-color: ${colors.red};
          color: #ffffff;
          border-color: ${colors.red};
        }

        @media (max-width: 575px) {
          font-size: 14px;
          width: 30px;
          height: 30px;
        }
      }
      button {
        cursor: pointer;
        outline: none;
      }
      &:last-child {
        margin-right: 0;
      }
    }
    li.active {
      a,
      button {
        background-color: ${colors.red};
        color: #fff;
        border-color: ${colors.red};
      }
    }
    li.disabled {
      a,
      button {
        color: ${colors.text3};
        cursor: not-allowed;
        background-color: #fff;
        border-color: ${colors.border3};
      }
      button:hover,
      a:hover {
        color: ${colors.text3};
        background-color: #fff;
        border-color: ${colors.border3};
      }
    }
    li button:disabled {
      color: ${colors.text3};
    }

    li.disabled button {
      pointer-events: none;
    }

    @media (max-width: 767px) {
      margin-top: 5px;
    }
  }
`;
